export const BULK_PRINT_START = 'BULK_PRINT_START';
export const startBulkPrint = (fulfillmentPlanIds, labelBatchId) => ({
  type: BULK_PRINT_START,
  fulfillmentPlanIds,
  labelBatchId,
});

export const BULK_PRINT_ACTIVE_LABEL_CHECK_START = 'BULK_PRINT_ACTIVE_LABEL_CHECK_START';
export const startActiveLabelCheck = (jobId) => ({
  type: BULK_PRINT_ACTIVE_LABEL_CHECK_START,
  jobId,
});

export const BULK_PRINT_EXECUTE_PRINT = 'BULK_PRINT_EXECUTE_PRINT';
export const executePrint = (jobId) => ({
  type: BULK_PRINT_EXECUTE_PRINT,
  jobId,
});

export const BULK_PRINT_GET_LABEL_PRINTED_STATUS = 'BULK_PRINT_GET_LABEL_PRINTED_STATUS';
export const getLabelPrintedStatus = (jobId) => ({
  type: BULK_PRINT_GET_LABEL_PRINTED_STATUS,
  jobId,
});

export const BULK_PRINT_END = 'BULK_PRINT_END';
export const endBulkPrint = (includedFulfillmentPlanIds, excludedFulfillmentPlanIds, warnFulfillmentPlanIds) => ({
  type: BULK_PRINT_END,
  includedFulfillmentPlanIds,
  excludedFulfillmentPlanIds,
  warnFulfillmentPlanIds,
});
